import * as React from 'react';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';
import { NavItem } from '~/shared/routing/createModuleNav';

type CRMRootLayoutProps = {
  children: React.ReactNode;
  moduleNavigation?: NavItem;
};

export const CRMRootLayout = ({
  children,
  moduleNavigation,
}: CRMRootLayoutProps) => (
  <ModuleLayout
    moduleNavigation={moduleNavigation}
    noContentPadding={true}
    className="@CRMRootLayout"
  >
    {children}
  </ModuleLayout>
);
